angular.module('app').config(confirmXmlsRouting);

function confirmXmlsRouting($routeProvider) {
  $routeProvider
    .when('/confirm_xmls', {
      pageTitle: 'CONFIRM_XML',
      template: '<confirm-xmls-page></confirm-xmls-page>',
      menu: 'purchases',
      accessPermission: 'index_confirmxml_accountadmin',
      authReq: true,
    })
    .when('/confirm_xmls/new', {
      params: {
        mode: null,
        xml: null,
        fromBooking: null,
      },
      pageTitle: 'ADD_CONFIRM_XML',
      template: '<confirm-xml-page></confirm-xml-page>',
      breadcrumb: {
        label: 'CONFIRM_XML',
        parent: 'confirm_xmls',
        ajs: true,
      },
      menu: 'purchases',
      accessPermission: 'create_confirmxml_accountadmin',
      authReq: true,
    })
    .when('/confirm_xmls/:id', {
      params: {
        mode: null,
        fromBooking: null,
      },
      pageTitle: 'EDIT_CONFIRM_XML',
      template: '<confirm-xml-page></confirm-xml-page>',
      breadcrumb: {
        label: 'CONFIRM_XML',
        parent: 'confirm_xmls',
        ajs: true,
      },
      menu: 'purchases',
      accessPermission: 'show_confirmxml_accountadmin',
      authReq: true,
    });
}

confirmXmlsRouting.$inject = ['$routeProvider'];
